import React from 'react'
import styles from 'css/components/generic-overlay.module.css'

type ButtonConfig = {
  text: string
  onClick: () => void
}

type GenericOverlayProps = {
  body: React.ReactNode
}

export const GenericOverlay: React.FC<GenericOverlayProps> = ({ body }) => {
  return (
    <div className="overlay">
      <div className="overlay-content-container">
        <div className="overlay-content-body">
          {body}
        </div>
      </div>
    </div>
  )
}


